import { propTypes } from '../../helpers'
import {
  AffiliationAdminPage,
  DocumentPage,
  ExternalPage,
  StoryPage,
  VisualizationPage
} from '../'

const PageFactory = ({ category }) => {
  switch (category.categoryType) {
    case 'ADMIN':
      return <AffiliationAdminPage category={category} />
    case 'DOCUMENT':
      return <DocumentPage category={category} />
    case 'EXTERNALMODULE':
      return <ExternalPage category={category} />
    case 'STORY':
      return <StoryPage category={category} />
    case 'VISUALIZATION':
      return <VisualizationPage category={category} />
    default:
      return null
  }
}

PageFactory.propTypes = {
  category: propTypes.categoryPropType.isRequired
}

export { PageFactory }
